export default __webpack_public_path__ + "static/media/wompi.42f4a965.svg";